import * as React from 'react';

import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import ContactsTable from '../../../components/Contact/ContactsTable/ContactsTable';
import useWindowResize from '../../../hooks/useWindowSize';
import { useGroupsList } from '../../../sic-lib/api/hooks/useGroupsList';
import { useSegments } from '../../../sic-lib/api/hooks/useSegments';
import { useGetViews } from '../../../sic-lib/api/hooks/useViews';
import { ListItem } from '../../../sic-lib/types/Lists';
import { View } from '../../../sic-lib/types/View';
import { defaultList } from '../../../sic-lib/utils/defaultList';
import { defaultView } from '../../../sic-lib/utils/defaultView';
import { hasMatchingListId, hasMatchingViewId } from '../../../sic-lib/utils/functionalFilters';
import { useAppSelector } from '../../../store/hooks';
import Header from '../Header/Header';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: '100%',
        overflow: 'hidden',
    },
    flexHeader: {
        flexBasis: '60px',
        flexGrow: 0,
        flexShrink: 0,
    },
}));

interface Props {
    listId: number;
}

export default function Layout({ listId }: Props) {
    const { classes } = useStyles();

    /*
        IMPORTANT: this is the screen size listener for the ConversationGridPage component tree,
        only one should be active within the page at a time.
     */
    const { hasMediumScreen } = useWindowResize();

    /* 
        Calculate applied list - 
        TIP: use resulting list for as much as the ConversationGrid component tree as possible to
        minimize number of times this filter is repeated, run
     */
    const allContactsView = useAppSelector(state => state.view.view);

    const { data: viewsData } = useGetViews();
    const { data: groupData } = useGroupsList();
    const { data: segmentData } = useSegments();

    const appliedList = React.useMemo(() => {
        if (listId > -2) {
            return groupData?.filter(hasMatchingListId(listId))[0] || defaultList;
        }
        return segmentData?.find(item => item.segmentId === listId) || defaultList;
    }, [listId, groupData, segmentData]);

    /*React.useEffect(() => {
        
        console.log('Layout: ', allLists, ' ListId: ', listId)

        const matchedList = allLists.filter(hasMatchingListId(listId))[0];


        if (matchedList) setAppliedList(matchedList);


    }, [allLists, listId]);*/

    /* 
        Calculate applied view - 
        TIP: use resulting view for as much as the ConversationGrid component tree as possible to
        minimize number of times this filter is repeated, run
     */
    const allViews = React.useMemo(() => {
        return viewsData || [];
    }, [viewsData]);

    const [appliedView, setAppliedView] = React.useState<View>(defaultView);

    React.useEffect(() => {
        if (listId > -2 && appliedList) {
            if (listId === -1) {
                setAppliedView(allContactsView);
                console.log('AllContact: ', allContactsView);
            } else {
                const matchedView = allViews.filter(
                    hasMatchingViewId((appliedList as ListItem).viewId),
                )[0];

                if (matchedView) setAppliedView(matchedView);
                console.log('Groups: ', matchedView);
            }
        }
    }, [allViews, appliedList, listId, allContactsView]);

    return (
        <Grid container direction="column" wrap="nowrap" className={classes.root}>
            <Grid item className={classes.flexHeader}>
                <Header appliedList={appliedList} />
            </Grid>
            <Grid item xs={true}>
                <ContactsTable
                    appliedList={appliedList}
                    appliedView={appliedView}
                    hasMediumScreen={hasMediumScreen}
                />
            </Grid>
        </Grid>
    );
}
